import { Stack, CircularProgress } from '@mui/material';

export function Loading() {
  return (
    <Stack alignItems="center">
      <CircularProgress sx={{ color: '#9667ED' }} />
    </Stack>
  );
}
